import { graphql } from '../gql';

export const getVendorAvailabilityList = graphql(`
  query GetVendorAvailabilityList {
    getVendorAvailabilityList {
      error {
        code
        message
      }
      vendors {
        vendorId
        internalName
        markets
        productType
        availabilityStatus
        submissionStatus
        windowStatus
        deadlineDate
        requiresSubmission
        submission {
          submittedAt
          submittedByEmail
          version
        }
      }
    }
  }
`);
